import { ChangeEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import styles from './EventColorInput.module.scss';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';

const EventColorInput = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const color = values.color ?? '#3174AD';

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        updateValues({ color: event.target.value.toUpperCase() });
    };

    return (
        <div className={styles.container}>
            <input
                id="event-color-input"
                type="color"
                value={color}
                onChange={onChange}
                className={styles.colorInput}
                aria-label={intl.formatMessage(messages.label)}
            />
            <label htmlFor="event-color-input" className={styles.label}>
                {intl.formatMessage(messages.label)}
                <span className={styles.value}>{color}</span>
            </label>
        </div>
    );
};

const messages = defineMessages({
    label: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventColorInput.label',
        defaultMessage: 'Kolor wydarzenia',
    },
});

export default EventColorInput;
